function notEmpty<TValue>(value: TValue | null | undefined | string): value is TValue {
  return value !== null && value !== undefined && value !== '';
}

export default notEmpty;
